import type { ComponentPropsWithoutRef } from "react";
import marinaLogoUrl from "../../assets/bj/marina.png";

type MarinaLogoProps = ComponentPropsWithoutRef<"img"> & { mask?: boolean };

export function MarinaLogo({ className, mask = false, alt = "", ...props }: MarinaLogoProps) {
  if (!mask) return <img src={marinaLogoUrl} alt={alt} className={className} {...props} />;

  return (
    <span
      className={`inline-block size-8 bg-blue-600 ${className}`}
      {...props}
      style={{
        maskImage: `url(${marinaLogoUrl})`,
        WebkitMaskImage: `url(${marinaLogoUrl})`,
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
